import {ref} from 'vue';

export default {
    install: (app, options) => {
        const notificationTypes = ref([]);

        const loadNotificationTypes = () => {

            window.lazy_axios.get(`/notifications/types`)
                .then((response) => {
                    if (response.data.types) {
                        notificationTypes.value = response.data.types;
                    }
                });
        };

        app.provide('notificationTypes', notificationTypes);
        app.provide('loadNotificationTypes', loadNotificationTypes);
    },
}
